import React, { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import { getSiteUrlWithoutProtocol, getSiteEmail } from "../Helpers/SiteConfig";
import usePageMeta from "../Helpers/usePageMeta";

const Disclaimer = () => {
  usePageMeta({
    title: "Disclaimer | TZ Creation",
    description: "Legal disclaimer for TZ Creation's website and services.",
    path: "/disclaimer",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <Breadcrumb parentpageName="Home" currentPageName="Disclaimer" />
      <section className="contact-page-area section-gap ">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="text-center">Legal Disclaimer</h1>
              <p className="text-justify mt-4">
                TZ Creation makes available information and materials (the
                "Information") on <a href="/">www.{getSiteUrlWithoutProtocol()}</a>, subject to
                the Terms of Use and this Disclaimer. This Disclaimer governs
                the use of our Website; by accessing this Website, you agree to
                the terms and conditions as outlined in the Terms of Use and
                this Disclaimer. If you disagree, please do not access this
                Website. We reserve the right to modify the Terms of Use and/or
                Disclaimer from time to time without any notice and at our sole
                discretion by posting amended Terms of Use and Disclaimer on
                this Website. By using this Website after the changes /
                modifications have been posted you agree to accept those changes
                / modifications, whether or not you have reviewed the changes /
                modifications.
              </p>

              <p className="text-justify mt-4">
                Data depicted and transmitted on the TZ Creation website{" "}
                <span className="mt-5 mb-1 font-w600">
                  (content such as directories, guides, articles, opinions,
                  reviews, text, pictures, illustrations, profiles, audio clips,
                  video clips, trademarks, service marks, etc.)
                </span>{" "}
                is completely secure under copyright and other intellectual
                property laws. Hereby, users accessing the website agree,
                neither to commit any unauthorized commercial exploitation of
                the content nor intent to modify, transmit, convert, transfer,
                publish, repost, sell, reuse, create derivative work from,
                distribute, perform, display, in any way. Thereby, users
                accessing the TZ Creation website content agree to abide by all
                the copyright notices and restrictions attached in any way.
              </p>

              <h2 className="mt-5 mb-2">COPYRIGHT</h2>
              <p>
                TZ Creation Copyright &copy; {new Date().getFullYear()} All
                rights reserved.
              </p>
              <p>
                Except as specifically permitted herein, no portion of the
                Information on this Website may be reproduced in any form or by
                any means without the prior written permission from TZ Creation.
              </p>
              <h2 className="mt-5 mb-2">TRADEMARKS</h2>
              <p>
                TZ Creation, and other TZ Creation graphics, logos, and service
                names including <a href="/">www.{getSiteUrlWithoutProtocol()}</a> are trademarks
                of TZ Creation. Except as specifically permitted herein, these
                Trademarks may not be used without the prior written permission
                from TZ Creation. All other trademarks not owned by TZ Creation
                that appear on this website are the property of their respective
                owners, who may or may not be affiliated with, connected to, or
                sponsored by TZ Creation.
              </p>

              <h2 className="mt-5 mb-2">USE OF WEBSITE INFORMATION</h2>
              <p>
                Subject to the terms and conditions set forth in the Terms of
                Use and this Disclaimer, TZ Creation grants you a
                non-transferable, non-exclusive, restricted and limited right to
                access, use and display this Website along with the contents.
                You agree and acknowledge that you will not interrupt or attempt
                to interrupt the functioning of this Website in any manner
                whatsoever and shall use & access this Website in accordance
                with the terms and conditions stated in Terms of Use and this
                Disclaimer.
              </p>
              <p className="mt-5 mb-1 font-w600">
                Except as otherwise indicated elsewhere on this Website, you may
                view, copy, print, and download the Information available on
                this Website subject to the following conditions:
              </p>
              <ul className="px-4" style={{ listStyle: "disc" }}>
                <li>
                  The Information may be used solely for personal and
                  informational purposes
                </li>
                <li>
                  The Information may not be modified or altered in any way
                </li>
                <li>
                  Any copy of the Information or portion thereof must include
                  the copyright notice above and this permission notice. You
                  must contribute all content taken by you from this Website to
                  TZ Creation
                </li>
                <li>
                  The Information shall not be disclosed to any other
                  person(s)/entity(ies) unless they are given notice of, and
                  they agree to accept, the obligations arising under the Terms
                  of Use
                </li>
                <li>
                  You shall also agree to abide by all additional restrictions
                  displayed on this Website and as may be updated from time to
                  time
                </li>
                <li>
                  TZ Creation reserves the right to revoke such authorization at
                  any time, and any such use shall be discontinued immediately
                  upon written notice from TZ Creation
                </li>
                <li>
                  Information specified above does not include the design or
                  layout of this Website. Further, you agree to comply with all
                  copyright and other intellectual property laws worldwide in
                  your use of this Website and to prevent any unauthorized
                  copying of the Information.
                </li>
                <li>
                  By sharing any contribution (including without limitation any
                  text, photographs, graphics, video or audio) with TZ Creation
                  or this Website you agree to grant TZ Creation / Website, free
                  of charge, permission to use the material in any way TZ
                  Creation wishes (including modifying or deleting it). In order
                  that TZ Creation / Website can use your contribution, you
                  confirm that your contribution is your own original work, is
                  not defamatory and does not infringe/ violate any relevant
                  laws (including but not limited to laws relating to communal
                  harmony, sedition etc.) and that you have the right to give TZ
                  Creation / Website permission to use it for the purposes
                  specified above.
                </li>
              </ul>

              <h2 className="mt-5 mb-2">GENERAL</h2>
              <p>
                TZ Creation, its mark and logo and other logos and names are
                Trademarks of TZ Creation. You understand and agree not to
                display or use these Trademarks in any manner without TZ
                Creation’s prior written permission. The section titles of this
                Disclaimer are displayed for convenience only and have no legal
                effect. Please send any questions or comments, or report
                violations of the with regard to this Website to{" "}
                <a href={`mailto:${getSiteEmail()}`}>{getSiteEmail()}</a>.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Disclaimer;
